// Composite packaging cell: replaces the old five separate UOM <Td>s
// (baseUnit/itemUnit/netContent/packUnit/packSize) with one compact summary.
// Clicking toggles the expander row (PackagingEditorRow) rendered by the
// parent row component directly below — this cell only owns the button/label.
import { Box, Text } from '@elkaso-app/web-design';
import { packagingInvalid, packagingSummary, type PackagingFields } from '../packaging';

interface Props {
  fields: PackagingFields;
  isExpanded: boolean;
  onToggle: () => void;
}

export const PackagingCell = ({ fields, isExpanded, onToggle }: Props) => {
  const invalid = packagingInvalid(fields);

  return (
    <Box
      as='button'
      type='button'
      onClick={onToggle}
      display='flex'
      alignItems='center'
      gap='1'
      textAlign='left'
      w='100%'
      minW='140px'>
      <Text fontSize='xs' color={invalid ? 'red.500' : 'gray.700'} fontWeight={invalid ? 'semibold' : 'normal'}>
        {packagingSummary(fields)}
      </Text>
      <Text as='span' fontSize='2xs' color='gray.400'>
        {isExpanded ? '▲' : '▼'}
      </Text>
    </Box>
  );
};
